import { render, staticRenderFns } from "./WizardFirstStep.vue?vue&type=template&id=522734b9&"
import script from "./WizardFirstStep.vue?vue&type=script&lang=js&"
export * from "./WizardFirstStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports